import { faqItems } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="section-padding bg-background-50">
      <div className="section-container max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-10 md:mb-14">
          常见问答
        </h2>

        <div className="space-y-4">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="rounded-2xl bg-background-100 border border-background-200/70 overflow-hidden"
            >
              <div className="p-5 md:p-6">
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 flex items-start gap-3">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-xs font-bold mt-0.5">
                    Q
                  </span>
                  {item.question}
                </h3>
                <p className="mt-3 pl-9 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}